import type { IWidgetConfig } from "../shared/session/interfaces/session";

export type RequestStatus =
  | "pending"
  | "accepted"
  | "funded"
  | "failed"
  | "expired"
  | "cancelled";

/** True when the payer may still create a fulfilling operation for this link. */
export const isRequestPayable = (config?: IWidgetConfig): boolean =>
  !config?.requestId ||
  !config.requestStatus ||
  config.requestStatus === "pending";

/** i18n key under `error.*` for the gate message matching request status. */
export const requestGateMessageKey = (
  status?: string
): string => {
  switch (status) {
    case "funded":
      return "error.requestAlreadyFulfilledMessageFunded";
    case "accepted":
      return "error.requestAlreadyFulfilledMessageAccepted";
    case "failed":
      return "error.requestAlreadyFulfilledMessageFailed";
    case "expired":
      return "error.requestAlreadyFulfilledMessageExpired";
    case "cancelled":
      return "error.requestAlreadyFulfilledMessageCancelled";
    default:
      return "error.requestAlreadyFulfilledMessage";
  }
};
